import type { ComponentChildren } from 'preact';

interface ButtonProps {
  children: ComponentChildren;
  variant?: 'primary' | 'danger' | 'ghost' | 'icon';
  size?: 'sm' | 'md';
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const VARIANT_CLASS: Record<string, string> = {
  primary: 'btn-primary',
  danger: 'btn-danger',
  ghost: 'btn-ghost',
  icon: 'btn-icon',
};

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  disabled,
  type = 'button',
}: ButtonProps) {
  const classes = [VARIANT_CLASS[variant], size === 'sm' ? 'btn-sm' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <button class={classes} onClick={onClick} disabled={disabled} type={type}>
      {children}
    </button>
  );
}
